module.exports = __webpack_public_path__ + "img/fallback_060_l.5f9b3a6c.jpg";